import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const StaffCaregiverPage = () => {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'discipline', label: 'Discipline' },
    { key: 'phone', label: 'Phone' },
    { key: 'email', label: 'Email' },
    { key: 'licenseNumber', label: 'License #' },
    { key: 'licenseExpiry', label: 'License Expiry' },
    { key: 'status', label: 'Status' },
  ];

  const initialData = [
    { id: '1', name: 'JOHNSON, SARAH', discipline: 'RN', phone: '(713) 555-0102', email: 'sjohnson@ivory.com', licenseNumber: 'RN-123456', licenseExpiry: '12/31/2025', status: 'Active' },
    { id: '2', name: 'RODRIGUEZ, MARIA', discipline: 'RN', phone: '(713) 555-0103', email: 'mrodriguez@ivory.com', licenseNumber: 'RN-234567', licenseExpiry: '06/30/2025', status: 'Active' },
    { id: '3', name: 'SMITH, JOHN', discipline: 'PT', phone: '(713) 555-0104', email: 'jsmith@ivory.com', licenseNumber: 'PT-345678', licenseExpiry: '03/31/2026', status: 'Active' },
    { id: '4', name: 'DAVIS, EMILY', discipline: 'OT', phone: '(713) 555-0105', email: 'edavis@ivory.com', licenseNumber: 'OT-456789', licenseExpiry: '09/30/2025', status: 'Active' },
    { id: '5', name: 'BROWN, MICHAEL', discipline: 'HHA', phone: '(713) 555-0106', email: 'mbrown@ivory.com', licenseNumber: 'HHA-567890', licenseExpiry: '12/31/2024', status: 'Inactive' },
  ];

  return (
    <GenericSetupPage
      title="Staff (Caregiver)"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Staff"
    />
  );
};

export default StaffCaregiverPage;
